import { render, staticRenderFns } from "./login_recuperarComponent.vue?vue&type=template&id=28725260&"
import script from "./login_recuperarComponent.vue?vue&type=script&lang=js&"
export * from "./login_recuperarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports